import { useRef, useState, useEffect, useCallback } from "react";
import Carousel from "react-bootstrap/Carousel";
import Short from "./Short";
import SideActions from "./SideActions";
import SaveToCollection from "../modals/SaveToCollection";
// import { IonIcon } from '@ionic/react';
// import { arrowUpOutline, arrowDownOutline } from 'ionicons/icons';
import { IoArrowUpOutline, IoArrowDownOutline } from "react-icons/io5";
import { groupData } from "../Constant/ConstantData";
import { TfiAlert } from "react-icons/tfi";

// Custom Spinner Component
const Spinner = () => (
  <div className="spinner">
    <div className="spinner-inner"></div>
    <style jsx>{`
      .spinner {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 100px;
        width: 100%;
        position: absolute;
        bottom: -23px;
        right: -67px;
      }
      .spinner-inner {
        border: 4px solid #f3f3f3;
        border-top: 4px solid #3498db;
        border-radius: 50%;
        width: 40px;
        height: 40px;
        animation: spin 1s linear infinite;
      }
      @keyframes spin {
        0% {
          transform: rotate(0deg);
        }
        100% {
          transform: rotate(360deg);
        }
      }
    `}</style>
  </div>
);

function ShortContainer({
  data,
  fullscreenState,
  handleToggleFullscreen,
  fetchVideos,
  pageNumber,
  setPageNumber,
  isLoading,
  onFocusInput,
  type,
}) {
  const shortContainerRef = useRef();
  const currentPlayingVideoRef = useRef(null); // Track the currently playing video
  const [activeIndex, setActiveIndex] = useState({});
  const [activeVideoIndex, setActiveVideoIndex] = useState({});
  const [isManuallyPaused, setIsManuallyPaused] = useState(false);
  const [show, setShow] = useState(false);
  const [selectedSave, setSelectedSave] = useState(null);
  const [isSubtitle, setIsSubtitle] = useState(true);
  const [speed, setSpeed] = useState("1.0");
  const [displayedVideos, setDisplayedVideos] = useState([]);
  const [isLoadingMore, setIsLoadingMore] = useState(false);

  const handleShow = (ele) => {
    setShow(true);
    setSelectedSave(ele);
  };

  const handleClose = () => {
    setShow(false);
    setSelectedSave(null);
  };

  const handleSelect = (carouselIndex, selectedIndex, e) => {
    if (e && e.type === "click") {
      e.preventDefault();
      setActiveIndex((prev) => ({
        ...prev,
        [carouselIndex]: selectedIndex,
      }));
      setActiveVideoIndex((prev) => ({
        ...prev,
        [carouselIndex]: selectedIndex,
      }));
    }
  };

  useEffect(() => {
    if (Array.isArray(data) && data.length > 0) {
      setDisplayedVideos(data.slice(0, 5)); // Initial batch of 5 videos
    }
    if (data?.length === 0) {
      setDisplayedVideos(data.slice(0, 0));
    }
  }, [data]);

  // Debounced scroll handler
  const debounce = (func, wait) => {
    let timeout;
    return (...args) => {
      clearTimeout(timeout);
      timeout = setTimeout(() => func(...args), wait);
    };
  };

  const handleScroll = useCallback(
    debounce(() => {
      setIsManuallyPaused(false);
      if (!shortContainerRef.current || isLoading || isLoadingMore) return;

      const { scrollTop, scrollHeight, clientHeight } =
        shortContainerRef.current;
      const isNearBottom = scrollHeight - scrollTop - clientHeight < 200;

      if (isNearBottom) {
        if (displayedVideos?.length < data?.length) {
          setIsLoadingMore(true);
          setTimeout(() => {
            setDisplayedVideos((prev) => [
              ...prev,
              ...data.slice(prev?.length, prev?.length + 5),
            ]);
            setIsLoadingMore(false);
          }, 500);
        } else {
          if (type == "myLikes") {
          } else {
            // setPageNumber((prevPage) => {
            //   const nextPage = prevPage + 1;
            //    fetchVideos();
            //   return nextPage;
            // });
          }
        }
      }
    }, 200),
    [
      data,
      displayedVideos,
      isLoading,
      isLoadingMore,
      fetchVideos,
      setPageNumber,
    ]
  );

  useEffect(() => {
    const container = shortContainerRef.current;
    if (container) {
      container.addEventListener("scroll", handleScroll);
      return () => container.removeEventListener("scroll", handleScroll);
    }
  }, [handleScroll]);

  const handleArrowUp = () => {
    if (shortContainerRef.current) {
      shortContainerRef.current.scrollTo({
        top: shortContainerRef.current.scrollTop - window.innerHeight,
        behavior: "smooth",
      });
    }
  };

  const handleArrowDown = () => {
    if (shortContainerRef.current && !isLoading && !isLoadingMore) {
      shortContainerRef.current.scrollTo({
        top: shortContainerRef.current.scrollTop + window.innerHeight,
        behavior: "smooth",
      });
    }
  };

  const formatDescription = (text) => {
    if (!text) return "";

    const urlRegex = /(https?:\/\/[^\s]+)/g;
    return text.split(urlRegex).map((part, index) => {
      if (part.match(urlRegex)) {
        return (
          <a
            key={index}
            href={part}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              display: "block",
              wordBreak: "break-all",
              color: "#007bff",
            }}
          >
            {part}
          </a>
        );
      }
      return <span key={index}>{part}</span>;
    });
  };

  return (
    <>
      <section ref={shortContainerRef} className="short-container">
        <style jsx>{`
          .short-container {
            scroll-behavior: smooth;
            overflow-y: auto;
            height: 100vh;
          }
          .reel {
            transition: opacity 0.3s ease;
          }
        `}</style>
        {Array.isArray(displayedVideos) &&
          displayedVideos.map((short, carouselIndex) => (
            <div
              className={` ${fullscreenState ? "fullScreenVideoReel" : "reel"}`}
              key={short._id} // Use a unique key to prevent unmounting
            >
              <div className="row main-reel-view">
                {fullscreenState ? null : (
                  <div className="col-md-5">
                    <div className="video-content">
                      <h2>{short?.title}</h2>

                      <div className="d-flex gap-2">
                        <span>
                          {" "}
                          <img
                            src={short?.categoryId?.image}
                            height={20}
                            width={20}
                          />
                        </span>
                        <p>- {short?.categoryId?.title}</p>
                      </div>
                      {short?.teacherDescription && (
                        <>
                          <h2 className="mt-3">What to expect</h2>
                          <p>{short?.teacherDescription}</p>
                        </>
                      )}
                      {/* <h6>{short?.description}</h6> */}
                      <h2 className="mt-3">Video Description</h2>
                      <p>{formatDescription(short?.description)}</p>
                      {/* {short?.isSensitive && (
                        <span>
                          <img
                            alt=""
                            src={require("../Assets/Images/Info.svg").default}
                          />{" "}
                          Sensitive content warning
                        </span>
                      )} */}
                      {short?.isSensitive && (
                        <>
                          <div className="alert-sec mb-2  mt-2">
                            <span className="tfialert">
                              <TfiAlert size={18} color="#000" />{" "}
                              <p className="alert-text">
                                - {short?.sensitiveType}
                              </p>
                            </span>
                          </div>
                        </>
                      )}
                      <div className=" grp-btns d-flex mt-1 flex-wrap">
                        {short?.group.map((id) => {
                          const name = groupData.find((g) => g.id === id)?.name;
                          return (
                            name && (
                              <button className="group-button ">{name}</button>
                            )
                          );
                        })}
                      </div>
                    </div>
                  </div>
                )}

                <div
                  className={` ${fullscreenState ? "col-md-10" : "col-md-7"}`}
                >
                  <div className="reel-video">
                    <Carousel
                      slide={false}
                      activeIndex={activeIndex[carouselIndex] || 0}
                      onSelect={(selectedIndex, e) =>
                        handleSelect(carouselIndex, selectedIndex, e)
                      }
                      controls={short?.isMultiple || false}
                      indicators={short?.isMultiple || false}
                    >
                      {short.videoParts?.map((video, index) => (
                        <Carousel.Item
                          key={`${short._id}-${index}`} // Unique key per video part
                          className={` ${
                            fullscreenState
                              ? "video-sec fullscreenStateAnother"
                              : "video-sec"
                          }`}
                        >
                          <Short
                            handleToggleFullscreen={handleToggleFullscreen}
                            shortContainerRef={shortContainerRef}
                            short={video}
                            index={index}
                            activeIndex={activeVideoIndex[carouselIndex] || 0}
                            vide0_id={short._id}
                            isSubtitle={isSubtitle}
                            speed={speed}
                            currentPlayingVideoRef={currentPlayingVideoRef}
                            carouselIndex={carouselIndex}
                            onFocusInput={onFocusInput}
                            isManuallyPaused={isManuallyPaused}
                            setIsManuallyPaused={setIsManuallyPaused}
                          />
                        </Carousel.Item>
                      ))}
                    </Carousel>
                    <SideActions
                      data={short}
                      handleShow={handleShow}
                      setIsSubtitle={setIsSubtitle}
                      isSubtitle={isSubtitle}
                      setSpeed={setSpeed}
                      speed={speed}
                      shortContainerRef={shortContainerRef}
                      fullscreenState={fullscreenState}
                    />
                  </div>
                </div>
              </div>
            </div>
          ))}
      </section>
      {isLoadingMore && !fullscreenState && <Spinner />}
      <div
        className={` ${
          fullscreenState
            ? "navigation-container-fullScreen"
            : "navigation-container"
        }`}
      >
        {/* <div onClick={handleArrowUp} className="nav-up">
  <IonIcon icon={arrowUpOutline} />
</div>
<div onClick={handleArrowDown} className="nav-down">
  <IonIcon icon={arrowDownOutline}  />
</div> */}

        <div onClick={handleArrowUp} className="nav-up">
          <IoArrowUpOutline style={{ color: "black" }} size={24} />
        </div>
        <div onClick={handleArrowDown} className="nav-down">
          <IoArrowDownOutline style={{ color: "black" }} size={24} />
        </div>
      </div>
      <SaveToCollection
        show={show}
        handleClose={handleClose}
        selectedSave={selectedSave}
        type="PlayBack"
        shortContainerRef={shortContainerRef}
      />
    </>
  );
}

export default ShortContainer;
